// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "input[type=date]::-webkit-calendar-picker-indicator{cursor:pointer}", "",{"version":3,"sources":["/home/execapi/backend/app/javascript/panel/components/BenefitForm/BenefitForm.scss"],"names":[],"mappings":"AAAA,oDACE,cAAA","file":"BenefitForm.scss","sourcesContent":["input[type=\"date\"]::-webkit-calendar-picker-indicator {\n  cursor: pointer;\n}\n"]}]);
// Exports
module.exports = exports;
